import React, { useState } from 'react';
import './Product.css';
import config from '../../config.json';
import priceFormat from '../Shared/showPriceFormat';
import Modal from './../Shared/Modal';
import Image from './../Shared/Image';
import { toPersian } from '../Shared/charactorsNormalize';


const Product = ({ data, currencyType }) => {
    const [showInfo, setShowInfo] = useState(false);

    const showInfoHandler = (event) => {
        event.stopPropagation();
        setShowInfo(true);
    }




    return (
        <React.Fragment>
            <div
                className={`single-item`}
            >
                <div
                    style={{
                        overflow: 'hidden', zIndex: 1, borderRadius: '17px'
                    }}
                >
                    <Image
                        src={`${config.server_address}/upload/${data.image}`}
                        width={'95px'}
                        height={'95px'}
                        borderRadius={'17px'}
                    />
                </div>
                <div className="middle-section">
                    <div style={{ minHeight: '44px', maxHeight: '44px', overflowY: 'auto', marginTop:'-5px' }}>{toPersian(data.name)}</div>
                    {/* <div className='starts'>
                        <span className='fa fa-star'></span>
                        <span className='fa fa-star'></span>
                        <span className='fa fa-star'></span>
                        <span className='fa fa-star'></span>
                        <span className='fa fa-star'></span>
                    </div> */}
                    <div className='middle-down'>
                        <div><button onClick={showInfoHandler}>جزئیات محتوا</button></div>
                        <div style={{textAlign:'left' }}>
                            <div>
                                {
                                    data.fakePrice ?
                                        <>
                                            <div className="price-item fake-price-item" style={{ letterSpacing: '.4px' }}>{toPersian(priceFormat(data.fakePrice))} {currencyType}</div>
                                            <div className='fake-price-line'></div>

                                        </>
                                        :
                                        <div style={{ minHeight: '22px' }}></div>

                                }
                                <div className="price-item" style={{ letterSpacing: '1px' }}>{data.price ? `${toPersian(priceFormat(data.price))} ${currencyType}` : null}</div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Modal
                show={showInfo}
                onCancel={() => setShowInfo(false)}
            >
                <div className='item-info-modal-container'>
                    <h1 onClick={() => setShowInfo(false)}>
                        <i className='fa fa-close'></i>
                    </h1>
                    <Image
                        src={`${config.server_address}/upload/${data.image}`}
                        width={'200px'}
                        height={'200px'}
                        borderRadius={'2px'}
                    />
                    <p style={{ marginTop: '15px', fontSize: '.9rem' }}>
                        {toPersian(String(data.content))}
                    </p>
                    <button onClick={() => setShowInfo(false)} style={{ color: '#000' }}>
                        متوجه شدم
                    </button>
                </div>
            </Modal>
        </React.Fragment>
    );
}

export default Product;